import React from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import QueueAnim from "rc-queue-anim";
import { tryNowRegister } from "../../utils";
import { useForm } from "react-hook-form";
import classnames from "classnames";

export const TryOn = (props) => {
  const { style } = props;
  const { t } = useTranslation();
  const { handleSubmit, register, errors } = useForm();
  const onSubmit = (values) => {
    if (values) {
      tryNowRegister(values.phone);
    }
  };
  const onError = (errors, e) => {
    console.log(errors);
  };
  return (
    <div className="try-on" style={style ? style : {}}>
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <input
          name="phone"
          placeholder={t("common.input-placeholder")}
          ref={register({
            required: true,
            pattern: {
              value: /^1[3-9]\d{9}$/,
              message: "error message", // JS only: <p>error message</p> TS only support string
            },
          })}
          className={classnames({ error: errors.phone })}
        />
        <button type="submit" className="try-on-button">
          {t("common.try-on")}
        </button>
      </form>
    </div>
  );
};
